import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Kostanay.png'
import _imports_1 from '@/assets/images/qostanay1.jpg'
import _imports_2 from '@/assets/images/qostanay2.jpg'
import _imports_3 from '@/assets/images/qostanay3.jpg'
import _imports_4 from '@/assets/images/qostanay4.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Костанайская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Костанайская область – востребованное направление экологического туризма в Казахстане. Здесь множество рек (только водотоков длиннее 10 км здесь более 300!) и водоемов (их тут более пяти тысяч), куда путешественники охотно отправляются в рыболовные туры за щукой и сазаном. Здесь также немало целебных соленых озер, на берегах которых расположены санатории и базы отдыха. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, " Что Еще Можно Предложить Путешественникам? ")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Как развивается туризм в Костанайской области? Сегодня туроператоры обратили внимание на историческую составляющую туристского потенциала региона. Выгодной может стать организация экскурсий в некрополь Бестамак, сохранившийся со времен бронзового века, или к архитектурному памятнику домусульманского периода Екидын с юртообразными сооружениями из природного камня. Найдется вариант и для тех, кто интересуется сплетением истории Казахстана и царской России – тур к Анновскому храму, который был возведен по указу и на средства таинственной фрейлины российской императрицы, волей случая оказавшейся в казахских степях. ")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "6124")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "27,9")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "215129")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "22435")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Семейный И Активный Отдых")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как показывает статистика туризма Казахстана Костанайская область достаточно популярна среди туристов. Регион граничит с тремя областями Российской Федерации, а потому здесь немало путешественников-россиян. Приезжают сюда туристы и из Европы. В Костанайской области нет рекордных температурных скачков и экстремальных погодных явлений, потому иностранным туристам здесь весьма комфортно. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Как показывает статистика, перспективными направлениями деятельности туристических фирм, организующий внутренний туризм в области являются охота, рыбалка, пешие экскурсии на природе, пляжный отдых. Кроме традиционных занятий, можно внедрять современные оригинальные виды отдыха – заезды на квадроциклах по степи, ралли по пересеченной местности. Поездки к "),
          /*#__PURE__*/_createVNode("b", null, "геоглифам в Тургайской долине"),
          /*#__PURE__*/_createTextVNode(". ")
        ]),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Интересны природно-познавательные туры в "),
          /*#__PURE__*/_createVNode("b", null, "Наурзумском заповеднике"),
          /*#__PURE__*/_createTextVNode(". Среди его достопримечательностей – реликтовый сосновый бор, соленые и пресные озера, но, как говорит статистика туризма, востребованными могут стать и оригинальные экскурсии, например, в "),
          /*#__PURE__*/_createVNode("b", null, "Тургайскую ложбину"),
          /*#__PURE__*/_createTextVNode(", к месту обнаружения вымерших животных – представителей индрикотериевого комплекса, которых теперь называют "),
          /*#__PURE__*/_createVNode("b", null, "Тургайской фауной"),
          /*#__PURE__*/_createTextVNode(". Еще одно перспективное направление – орнитологические туры на "),
          /*#__PURE__*/_createVNode("b", null, "Наурзумские озера"),
          /*#__PURE__*/_createTextVNode(", удачно расположенные на путях миграции множества видов птиц, зимующих в Средней Азии, Индии и Иране. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "regio-swiper" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}